export default "__VITE_ASSET__CtmITeLB__"